var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_351_2893)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8.5,
    width: 44,
    height: 44,
    rx: 12,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.25 38.75C25.25 39.9905 26.2595 41 27.5 41C28.7405 41 29.75 39.9905 29.75 38.75C29.75 37.5095 28.7405 36.5 27.5 36.5C26.2595 36.5 25.25 37.5095 25.25 38.75ZM28.25 38.75C28.25 39.1632 27.9132 39.5 27.5 39.5C27.0868 39.5 26.75 39.1632 26.75 38.75C26.75 38.3368 27.0868 38 27.5 38C27.9132 38 28.25 38.3368 28.25 38.75ZM38.75 38.75C38.75 37.5095 37.7405 36.5 36.5 36.5C35.2595 36.5 34.25 37.5095 34.25 38.75C34.25 39.9905 35.2595 41 36.5 41C37.7405 41 38.75 39.9905 38.75 38.75ZM35.75 38.75C35.75 38.3368 36.0868 38 36.5 38C36.9132 38 37.25 38.3368 37.25 38.75C37.25 39.1632 36.9132 39.5 36.5 39.5C36.0868 39.5 35.75 39.1632 35.75 38.75ZM23.075 20.75L24.3628 32.9855C24.42 33.5389 24.6806 34.0513 25.0941 34.4235C25.5075 34.7956 26.0444 35.0011 26.6007 35H38.288C38.8024 34.9977 39.3006 34.8203 39.7006 34.4969C40.1006 34.1735 40.3785 33.7235 40.4885 33.221L42.29 24.8142C42.3373 24.5956 42.3349 24.3691 42.2828 24.1515C42.2308 23.9339 42.1304 23.7308 41.9893 23.5573C41.8489 23.3829 41.6711 23.2423 41.4691 23.1459C41.2671 23.0494 41.0461 22.9996 40.8223 23H24.8203L24.4962 19.922C24.477 19.7375 24.39 19.5668 24.2522 19.4427C24.1144 19.3186 23.9355 19.2499 23.75 19.25H21.5C21.3011 19.25 21.1103 19.329 20.9697 19.4697C20.829 19.6103 20.75 19.8011 20.75 20C20.75 20.1989 20.829 20.3897 20.9697 20.5303C21.1103 20.671 21.3011 20.75 21.5 20.75H23.075ZM40.8223 24.5L39.0215 32.9067C38.9473 33.2502 38.639 33.5 38.2873 33.5H26.6007C26.4153 33.5004 26.2363 33.432 26.0984 33.308C25.9606 33.184 25.8736 33.0132 25.8545 32.8287L24.9777 24.5H40.8223Z",
    fill: "#5E72E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_351_2893",
    x: 0,
    y: 0.5,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.486275 0 0 0 0 0.552941 0 0 0 0 0.709804 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_351_2893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_351_2893",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cartIcon.f94c00cfb405fcfb11f2e6416e679732.svg";
export { ForwardRef as ReactComponent };